import { colors } from "../../../../data/colors";

export default function useCreateIcon() {
  const iconStyle = { fontSize: 22, color: colors.white };

  return { iconStyle };
}
